webpackJsonp([73],{

/***/ 1235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Features_ui_components_Loadable__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_actions__ = __webpack_require__(494);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import { getServiceToken } from 'Lib'


var AsyncLoginBSRSForm = Object(__WEBPACK_IMPORTED_MODULE_5_Features_ui_components_Loadable__["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1225));
	}
});

var LoginBSRS = function (_PureComponent) {
	_inherits(LoginBSRS, _PureComponent);

	function LoginBSRS() {
		_classCallCheck(this, LoginBSRS);

		return _possibleConstructorReturn(this, (LoginBSRS.__proto__ || Object.getPrototypeOf(LoginBSRS)).apply(this, arguments));
	}

	_createClass(LoginBSRS, [{
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsyncLoginBSRSForm, {
				onSubmit: this.props.authorizeProfile
			});
		}
	}]);

	return LoginBSRS;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */], Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, props) {
	return {};
}, function (dispatch, _ref) {
	var history = _ref.history;
	return {
		authorizeProfile: function authorizeProfile(value) {
			// dispatch(authorizeProfile(value))
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* authorizeBSRS */])(value));
		},
		setError: function setError(hasError, errorCode) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__ui_actions__["a" /* setError */])(hasError, errorCode));
		}
	};
}))(LoginBSRS));

/***/ })

});


// WEBPACK FOOTER //
// 73.65db42a108b09490c378.js